
import EventDispatcher from '@/base/event/event-dispatcher';
import $ from 'jquery';
import screenfull from 'screenfull';
import tmpl from './tmpl/_screenfull.art';
import './tmpl/screenfull.scss';


class Pager extends EventDispatcher {
    constructor(options, $parent) {
        super();
        this.percentage = 100
        this.isFullscreen = false;
        this.contentWidth = $('.content').width()
        this.$parent = $parent || $('body'); // 当前元素
        this.options = options || {};
        this.render();
        this.bindEvents();

        this.change()
    }

    change() {
        this.isFullscreen = !this.isFullscreen
        if (this.isFullscreen) {
            this.$el.find('.icon-srt-fullscreen').show()
            this.$el.find('.icon-srt-exit-fullscreen').hide()
        } else {
            this.$el.find('.icon-srt-fullscreen').hide()
            this.$el.find('.icon-srt-exit-fullscreen').show()
        }
    }

    render() {
        this.$el = $(tmpl(this.options));
        this.$parent.append(this.$el);
        return this;
    }

    bindEvents() {
        this.$el.on('click', '[data-action="screenFull"]', evt => {
            if (!screenfull.isEnabled) {
                console.log('浏览器不支持')
                return false
            }
            screenfull.toggle()
            this.change()
        });
    }
}

export default Pager;